import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { SponsoredListPaginatorInterface } from '../../../shared/models/sponsored.list.paginator.interface';
import moment from 'moment';
import { PaginatorInterface } from '../../../shared/models/paginator.interface';
import {
  ESponsoredListActions,
  GetSponsoredList,
  GetSponsoredListSuccess
} from '../../../shared/store/actions/sponsored-list.actions';
import { Store } from '@ngrx/store';
import { UpdatePaginator } from '../../../shared/store/actions/paginator.actions';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-sponsorship-management',
  templateUrl: './sponsorship-management.component.html',
  styleUrls: ['./sponsorship-management.component.css'],
  standalone: false
})
export class SponsorshipManagementComponent implements OnInit {

  brand?: string;
  sponsoredList: SponsoredListPaginatorInterface|null;
  currentSelectedPage: number;
  totalItemsPerPage: number ;

  constructor(
      private store: Store<any>,
      private action$: Actions
  ) {}

  ngOnInit() {
    this.sponsoredList = null;
    this.currentSelectedPage = 1;
    this.totalItemsPerPage = 5;
    this.brand = environment.data.brand;
    this.store.dispatch(new GetSponsoredList(this.currentSelectedPage, this.totalItemsPerPage));
    this.action$.pipe(ofType(ESponsoredListActions.GetSponsoredListSuccess)).subscribe((response: GetSponsoredListSuccess
    ) => {
      if (response.payload) {
        this.sponsoredList = response.payload;
        this.store.dispatch(new UpdatePaginator(this.getPaginator('sponsorship')));
      }
    });
  }

  getHumanStatus(status: string) {
    switch (status) {
      case 'sponsor_failed_referee_credited':
        return 'Parrain annulé, filleul crédité';
      case 'waiting_credit':
        return 'Avoir en attente';
      case 'validation_in_progress':
        return 'Commande en attente de validation';
      case 'referee_credited':
        return 'Filleul crédité';
      case 'sponsor_credited':
        return 'Parrain crédité';
      case 'referee_failed':
      case 'sponsor_failed':
      case 'failed_tunnel':
        return 'Annulé';
      case 'failed_order':
        return 'Commande annulée';
      case 'in_progress_tunnel':
        return 'Commande en cours';
      default:
        return 'Commande en cours';
    }
  }

  formattingDate(updatedAt: string) {
    return moment(updatedAt, 'YYYY-MM-DD H:m:s').format('DD/MM/YYYY');
  }

  private getPaginator(type?: string) {
    return {
      currentSelectedPage: this.sponsoredList.currentPage,
      selectedLine: null,
      action: GetSponsoredList,
      totalItems: this.sponsoredList.totalItems,
      type,
    } as PaginatorInterface;
  }
}
